import { environment } from "@/lib/constants.ts";
import { ApolloClient, InMemoryCache } from "@apollo/client";

export const apolloClient = new ApolloClient({
  uri: environment.unlockSubgraphURL,
  cache: new InMemoryCache(),
});

export const oiApolloClient = new ApolloClient({
  uri: environment.oiGQLUrl,
  cache: new InMemoryCache(),
});
